import { render, staticRenderFns } from "./NotificationsPageContainer.vue?vue&type=template&id=2e46b24d&"
import script from "./NotificationsPageContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationsPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports